import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';

function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="pt-20 pb-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
        {/* Content will be added later */}
      </div>
      <Footer />
    </div>
  );
}

export default Privacy; 